import styled from 'styled-components'

export const Wrapper = styled.div`
  p {
    word-break: break-word;
  }
` as any
